import { DROP_UPLOAD_KEYS_ON_SUCCESS } from 'root/src/client/logic/tableItem/actionIds'

export default payload => ({
	type: DROP_UPLOAD_KEYS_ON_SUCCESS,
	payload,
})
